import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function CampaignsMarketing({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                d="M3.6 20.5q-.66 0-1.13-.477Q2 19.545 2 18.875v-9.75q0-.67.47-1.148T3.6 7.5h12.8q.66 0 1.13.477.47.478.47 1.148v9.75q0 .67-.47 1.148t-1.13.477zm6.4-5.687L3.6 10.75v8.125h12.8V10.75zm0-1.626 6.4-4.062H3.6zM3.6 10.75V9.125v9.75zm17.957.75-.987-1.004a4.8 4.8 0 0 0 1.099-1.57A4.7 4.7 0 0 0 22.067 7q0-1.02-.398-1.91a4.8 4.8 0 0 0-1.099-1.554l.987-1.036a6.5 6.5 0 0 1 1.418 2.023Q23.5 5.69 23.5 7t-.526 2.477a6.5 6.5 0 0 1-1.417 2.023M19.52 9.428 18.5 8.392a2.3 2.3 0 0 0 .462-.623q.175-.348.175-.769 0-.42-.175-.769a2.3 2.3 0 0 0-.462-.623l1.02-1.036q.508.47.795 1.093.287.622.287 1.335 0 .712-.287 1.335a3.4 3.4 0 0 1-.796 1.093"
            />
        </svg>
    );
}

export default CampaignsMarketing;
